var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('router-view',{staticClass:"content"}),_c('BaseFooter'),(_vm.userList.length > 0)?_c('Depositdue'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }